<template>
	<div class="TQ_center">

		<!-- table-->
		<tq-card width="100%" padding="8px" margin="16px">

			<!-- Table -->
			<tq-table
					:rows="questEvents_a"
					:system-lang-code="store_system_langCode_ve.val"
					:display-search="true"
					:p_click-row_f="m_clickRowEvent_f"
					p_td-classes_s="TQ_padding_8px"
					:columns="[
				        {label : 'stating date',		field(row){return format_dateFull(row.qev_startingDate_t)}},
                        {label : 'Name',				field(row){return row.cm_qev_getName_fs(store_system_langCode_ve.val)}},
                        {label : 'Quest Id',			field : 'qev_questId_uid'},
                        {label : 'quest type',			field : 'qev_questType_e'},
                        {label : 'event id',			field : 'qev_eventId_uid'},
                        {label : 'duration (minutes)',	field : 'qev_durationInMinutes_n'},
                        {label : 'qev_ticketsStatus_byTicketId_b',			field : (row) => {return row.qev_ticketsStatus_byTicketId_b}},
                    ]"
			/>

			<!-- search -->
			<tq-dropdown :style-select="true"
			             class="TQ_width_200px TQ_verticalAlignMiddle TQ_margin_4px">

				<div slot="select" >
					{{selectedQuestType}}
				</div>

				<div slot="options"
				     @click="selectedQuestType = questType"
				     v-for="questType in enum_questTypes">
					{{questType}}
				</div>

			</tq-dropdown>
			<input class="TQ_input TQ_width_200px TQ_verticalAlignMiddle TQ_margin_4px"
			       placeholder="questId"
			       v-model="selectedQuestId"/>
			<tq-loader-button text="Get Quest Events"
			                  btn-class="TQ_btn TQ_bg_green"
			                  @clickBtn="m_getQuestEvents_f"
			                  :show-loader="showBtnLoader_b"/>
			<div class="TQ_btn TQ_bg_gold_w TQ_margin_4px"

			     @click="showBtnLoader_b = false">
				{{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}
			</div>

		</tq-card>

		<!-- event action-->
		<tq-card width="100%" padding="8px" margin="16px" v-if="selectedEvent" max-width="450px">

			<div>{{selectedEvent.qev_eventId_uid}}</div>
			<div>{{format_dateFull(selectedEvent.qev_startingDate_t)}}</div>
			<hr>

			<div class="TQ_grid_col_1frAuto TQ_margin_4px">
				<div> {{ass_strings.threeWords_startingDateTime[store_system_langCode_ve.val]}} </div>

				<!-- select starting date-->
				<input  class="TQ_input"
				        v-model="selectedDate_s"
				        @change="m_changeStartingDate_f"
				        type="datetime-local"
				        min="2018-09-01T00:00"
				        max="2025-12-30T00:00">
			</div>

			<div class="TQ_grid_col_1frAuto TQ_margin_4px">
				<div> {{ass_strings.twoWords_durationMinutes[store_system_langCode_ve.val]}} </div>
				<input class="TQ_center TQ_input"
				       v-model.number="selectedEvent.qev_durationInMinutes_n"
				       type="number"/>


			</div>

			<hr>

			<!-- update button -->
			<tq-btn-approve
					v-if="co_updatedEvent_b"
					class="TQ_bg_gold_w TQ_btn TQ_borderRadius TQ_margin_4px"
					:system-lang-code="store_system_langCode_ve.val"
					:text="ass_strings.oneWord_update"
					:popup-text="ass_strings.question_updateEvent"
					:approve-cb="m_updateEvent_f"/>

			<!-- delete button -->
			<tq-btn-approve
					class="TQ_bg_red TQ_btn TQ_borderRadius TQ_margin_4px"
					:system-lang-code="store_system_langCode_ve.val"
					:text="ass_strings.oneWord_delete"
					:popup-text="ass_strings.question_deleteEvent"
					:approve-cb="m_deleteEvent"/>

			<!-- buy new ticket -->
			<div @click="showBuyQuestPopup_vb.val = true"
			     class="TQ_btn TQ_bg_green TQ_borderRadius TQ_margin_4px">
				<div> {{ass_strings.fourWords_buyAnEntranceTicket[store_system_langCode_ve.val]}}</div>

				<tq-popup :show="showBuyQuestPopup_vb" width="100%" margin="16px" padding="8px" maxWidth="350px" class="TQ_center TQ_textColor_black">

					<div>
						<div> {{ass_strings.oneWord_spots[store_system_langCode_ve.val]}} </div>
						<input type="number" v-model.number="newTicket_spots_n"/>
					</div>

					<tq-loader-button
							v-if="server_questExplore_c"
							:text=ass_strings.twoWords_createTicket[store_system_langCode_ve.val]
							btn-class="TQ_bg_green TQ_text_20px TQ_btn TQ_margin_16px"
							@clickBtn="m_adminBuyTicket_f()"
							:show-loader="newTicket_btnLoader_adminBuyTicket_b"/>

					<div v-else>
						<ball-pulse-sync-loader color="#2E294E" size="10px"/>
					</div>
				</tq-popup>

			</div>

		</tq-card>

		<!-- -->
		<table class="TQ_center">
			<tr v-for="playerData_c in playersData_byId_c" >
				<td v-if="playerData_c">
					{{playerData_c.ud_name_s}}
				</td>
				<td v-if="playerData_c">
					{{playerData_c.ud_email_s}}
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
    import TqDropdown from "../../components/basic/TqDropdown";

    import TqCard from "../../components/basic/TqCard";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {obj_forEach_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import {notification_notify} from "../../scripts/S_Notification";
    import TqTable from "../../components/basic2/TqTable";
    import {format_date_YYYY_MM_DD_hh_mm_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {FB_QuestTicket, FB_QuestTicket_History} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import {FB_Cost} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqPopup from "../../components/basic/TqPopup";
    import {
        enum_accessLevelOptions,
        enum_costCurrency_n,
        enum_questTypes,
        enum_questTicketStatus,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {
        server_creatorRequestTicket_f,
        server_questEvents_cl_set_f,
        server_questEvent_update_f, server_getQuestTicket_once_f
    } from "../../scripts/Server/S_ServerPre";
    import {serverBig_questExplore_once_f} from "../../scripts/Server/S_ServerFirestore";
    import {date_getNowDate_resetSeconds_fd, date_newDate_fd} from "../../scripts/S_Date";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f, serverAuth_getOtherUserData_f
    } from "../../scripts/Server/S_ServerAuth";

    export default {
        name: "v_Admin_Manage_Events",
        components: {TqPopup, TqBtnApprove, TqTable, TqLoaderButton, TqCard, TqDropdown},

        data(){
            return {
                selectedQuestType       : enum_questTypes.CARDS,

                newTicket_btnLoader_adminBuyTicket_b : false,
                newTicket_spots_n       : 10,

                showBuyQuestPopup_vb    : {val : false},
                selectedQuestId                 : '',
                selectedEvent           : null,
                oldSelectedEvent_s      : null,
                selectedDate_s          : '',
                showBtnLoader_b         : false,
                questEvents_a           : [],
                playersData_byId_c : {},

                // server
                server_questExplore_c : undefined,
                server_currentUserData_c : undefined,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // imports
                enum_questTypes         : enum_questTypes,
                ass_strings             : ass_strings,
                format_dateFull         : format_date_YYYY_MM_DD_hh_mm_fs,
                enum_accessLevelOptions : enum_accessLevelOptions,

            }
        },
	    computed:{
            co_updatedEvent_b(){
                return JSON.stringify(this.selectedEvent) !== this.oldSelectedEvent_s
            },
	    },
        methods:{

			// m_getQuestEvents_f
            m_getQuestEvents_f(){
                if(!this.selectedQuestId || this.selectedQuestId === ''){
                    notification_notify(ass_strings.oneWord_error, ass_strings.threeWords_enterQuestId)
                    return
                }

                this.showBtnLoader_b = true
                this.questEvents_a = []

                server_questEvents_cl_set_f(
                    this.$options.name,
                    this.selectedQuestType,
                    this.selectedQuestId,
                    null,
                    null,
                    (questEvent) => {
                        this.showBtnLoader_b = false


                        // obj_forEach_f(questEvent.qev_ticketsStatus_byTicketId_b, (ticketStatus_bm, ticketId_uid) => {
		                 //    server_getQuestTicket_once_f(ticketId_uid, (questTicket_c) => {
                        //
		                 //        if(questTicket_c == null){
		                 //            return
		                 //        }
                        //
                        //         obj_forEach_f(questTicket_c.qt_playersJoinDate_byUserId_t, (joinDate_t, playerId_uid) => {
                        //
                        //             server_getOtherUserData_f(playerId_uid, (playerData_c) => {
                        //                 this.$set(this.playersData_byId_c, playerId_uid ,playerData_c)
                        //             })
                        //         })
		                 //    })
                        // })

                        this.questEvents_a.push(questEvent)
                    },
                )

            },

	        // m_clickRowEvent_f
            m_clickRowEvent_f(row){
                this.oldSelectedEvent_s = JSON.stringify(row)
				this.selectedEvent = row

                this.server_questExplore_c = undefined;

                serverBig_questExplore_once_f(this.selectedEvent.qev_questId_uid, false, (questExplore_c) => {
	                this.server_questExplore_c = questExplore_c
	            })

            },

	        // m_changeStartingDate_f
            m_changeStartingDate_f(e){

                this.selectedEvent.qev_startingDate_t = (date_newDate_fd(this.selectedDate_s)).getTime()
	        },

	        // m_adminBuyTicket_f
            m_adminBuyTicket_f(){

                let cost_c = new FB_Cost({
                    c_currency_e : enum_costCurrency_n.SHEKEL,
	                c_value_n : 0,
                })

	            if(this.newTicket_spots_n < 0 ){
                    notification_notify(ass_strings.oneWord_error)
	            }

                this.newTicket_btnLoader_adminBuyTicket_b = true


                let newQuestTicket_c = new FB_QuestTicket({
                    qt_ticketId_uid : null,
                    qt_shortKeyId_s : this.server_questExplore_c.qex_shortKeyPrefixId_s,
                    qt_questId_uid  : this.server_questExplore_c.qex_questId_uid,
                    qt_questType_e  : this.server_questExplore_c.qex_questType_e,
                    qt_creatorId_uid  : this.server_questExplore_c.qex_creatorId_uid,
                    qt_eventId_uid  : this.selectedEvent.qev_eventId_uid ,
                    qt_eventStartingDate_t  :this.selectedEvent.qev_startingDate_t,

                    qt_playerId_uid        : this.server_currentUserData_c.ud_userId_uid,

                    qt_playersJoinDate_byUserId_t   : {},
                    qt_saleDate_t                   : date_getNowDate_resetSeconds_fd().getTime(),
                    qt_purchasedBy_e                : enum_accessLevelOptions.admin,

                    qt_status_e     : enum_questTicketStatus.waitingToApprove,
                    qt_history_ac   : [new FB_QuestTicket_History({
                        qth_timestamp_t    : (date_getNowDate_resetSeconds_fd()).getTime(),
                        qth_actions_e      : enum_questTicketStatus.waitingToApprove
                    })],

                    qt_spots_n  : this.newTicket_spots_n,
                    qt_cost_c   : cost_c,
                })

                server_creatorRequestTicket_f(newQuestTicket_c, null).then( () => {
                    this.newTicket_btnLoader_adminBuyTicket_b = false
                    notification_notify(ass_strings.threeWords_createdNewTicket)
                })


            },

	        // m_updateEvent_f
            m_updateEvent_f(){
                server_questEvent_update_f(this.selectedEvent, () => {
                    console.log(this.selectedEvent)
                })
            },

	        // m_deleteEvent
            m_deleteEvent(){
                // server_deleteQuestEvent(this.selectedEvent, ()=>{})
            },

        },
	    created(){
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {
                this.server_currentUserData_c = userData_c
            })
	    },
	    destroyed(){
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
	    }

    }
</script>

<style scoped>

</style>